import { Component, OnInit, Input } from '@angular/core';
import { FeedDto, ParticipantDto } from 'src/app/models/feed.model';

@Component({
  selector: 'app-post-feed',
  templateUrl: './post-feed.component.html',
  styleUrls: ['./post-feed.component.css']
})
export class PostFeedComponent implements OnInit {

  // Post Component takes in an input for data
  @Input() post: FeedDto;
  @Input() postParticipant: ParticipantDto;
  postDate = new Date(0);

  constructor() { }

  ngOnInit(): void {
    this.postDate.setUTCSeconds(this.post.modified);
  }

}
